import { onDocumentEvent } from '@app/utils/domHelpers'
// Sanitization
//
// Uses regexps to sanitize input in inputfields
//
// Examples:
//   Allow numbers and commas:
//   <input type="text" data-allowed-chars="0-9,">
//
const removeInvalidChars = function (inputBox, invalidRegExp) {
  const original = inputBox.value

  if (invalidRegExp.test(original)) {
    inputBox.value = original.replace(invalidRegExp, '')
  }
}

const createInputFilter = (regexpData, regexpBuilder) => (e) => {
  const input = e.target
  const regexp = regexpBuilder(input.dataset[regexpData])
  removeInvalidChars(input, regexp)
}

const allowedCharsBuilder = (filter) => new RegExp(`[^${filter}]`, 'ig')
const allowedChars = createInputFilter('allowedChars', allowedCharsBuilder)

export default () => {
  const removeWhitelistListener = onDocumentEvent(
    document,
    'keyup',
    '[data-allowed-chars]',
    allowedChars
  )

  return () => {
    removeWhitelistListener()
  }
}
